<style scoped>
    @import url("../../styles/smartControl/defGeralSmartControl.scss");
</style>

<template>
    <div class="box_defSC">

        <!-- MAIN TIT -->
        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-cogs</v-icon>
            <span class="ml-2">Definições</span>
        </div>

        <!-- Caixa de diálogo aberta após input de atualização -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div v-if="!flagLoading && flagDialog">
                <DialogMsg 
                v-if="flagDialog" 
                :msgFromFather="msg2child"
                @fromDialogMsg="flagDialog = false" 
                />
            </div>
        </v-dialog>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- definições gerais do sistema -->
        <div class="painelGeral" v-if="!flagLoading">
            
            <fusoSC :agent_unit="agent_unit" @fromChildUpFuso="upEstruturaOp($event,'fuso')" />

            <DefGeralAgent :agent_unit="agent_unit" @estruturaFromChild="upEstruturaOp($event,'all')" />

        </div>

    </div>
</template>

<script>
import axios from 'axios'

import fusoSC from './defGeral/fusoSC'
import DefGeralAgent from './defGeral/DefGeralAgent'
import DialogMsg  from './defGeral/DialogMsg'

export default {

    components:{fusoSC,DefGeralAgent,DialogMsg},

    data() {
        return {
            flagLoading:false, // loading
            flagDialog:false, // dialog final
            msg2child:'', // dialog final
        }
    },

    methods:{

        upEstruturaOp(e,marcadorLocal) {
            //console.log(e) // <-- json a ser atualizado no agent (estrutura)

            this.flagLoading = true // -- open loading

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let params = {'cliente':cl, 'sistema':this.sistema, 'el_estrutura':e}

            let self = this
            const url = self.$store.state.pathAxiosBASE + '/upestrutura'
            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result) // agent 
                const strConfirm = res.data.result // agent_unit

                if (strConfirm == 'ok') {
                    
                    self.msg2child = 'Atualizado.'

                    if (marcadorLocal == 'fuso') {
                        // -- atualizar a informação local (front) do sistema.
                        const fusoHorarioSC = e['fuso_horario']
                        self.$store.state.fusoHorarioSC = fusoHorarioSC // 02/05/2026
                        localStorage.setItem('fusoHorarioSC', JSON.stringify(fusoHorarioSC)) // 02/05/2026
                    }
                }
                else {
                    
                    self.msg2child = 'Não foi possível atualizar. Tente novamente mais tarde.'
                }
                self.flagDialog = true // abrir dialog com informações do input feito.

                // -- reset
                //self.flagLoading = false // -- encerrar loading
                self.init() // buscar a atualização realizada agora.
            })
        },

        init() {

            this.flagLoading = true // -- open loading

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':cl, 'sistema':this.sistema}

            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log(res.data.result) // agent 
                self.agent_unit = res.data.result // agent_unit
                self.flagLoading = false

            })
        },
    },

    created() {
        window.scrollTo(0,0)
        this.init()
    }
}
</script>